import { lazy } from 'react'

export const FlowInstancesPageLazy = lazy(() => import('./FlowInstances'))
